module.exports = __webpack_public_path__ + "static/media/logo-npo-banner-light.ade86c39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-npo-banner-light.png
// module id = 618
// module chunks = 36